<template>
  <portal to="ModalRecommendation">
    <div class="modal-backdrop overflow-auto py-sm-3 py-xl-5">
      <div class="card">
        <div class="d-flex justify-content-end">
          <a>
            <img
              src="@/assets/icon/close.png"
              alt="close"
              @click="$emit('close', 'create')"
            >
          </a>
        </div>
        <div class="d-flex justify-content-center">
          <h5 class="font-weight-bold my-3">
            {{ $t('manage-question.head.update-criteria') }}
          </h5>
        </div>
        <div class="card-body">
          <div class="mb-3">
            <small class="font-weight-bold">
              {{ $t('manage-question.label.risk') }}
            </small>
            <input
              v-model="form.risk"
              type="text"
              class="form-control form-control-sm"
              :class="{'border border-danger': $v.form.risk.$error}"
            >
            <template v-if="!$v.form.risk.required && $v.form.risk.$error">
              <small class="text-danger">
                {{ $t('manage-question.error.required', { name: $t('manage-question.label.risk') }) }}
              </small>
            </template>
          </div>
          <div class="mb-3">
            <small class="font-weight-bold">
              {{ $t('manage-question.label.pattern') }}
            </small>
            <input
              v-model="form.pattern"
              type="text"
              class="form-control form-control-sm"
              :class="{'border border-danger': $v.form.pattern.$error}"
            >
            <template v-if="!$v.form.pattern.required && $v.form.pattern.$error">
              <small class="text-danger">
                {{ $t('manage-question.error.required', { name: $t('manage-question.label.pattern') }) }}
              </small>
            </template>
            <template v-if="!$v.form.pattern.numeric && $v.form.pattern.$error">
              <small class="text-danger">
                {{ $t('manage-question.error.characters') }}
              </small>
            </template>
          </div>
          <div class="mb-3">
            <small class="font-weight-bold">
              {{ $t('manage-question.label.criteria') }}
            </small>
            <input
              v-model="form.criteria"
              type="text"
              class="form-control form-control-sm"
              :class="{'border border-danger': $v.form.criteria.$error}"
            >
            <template v-if="!$v.form.criteria.required && $v.form.criteria.$error">
              <small class="text-danger">
                {{ $t('manage-question.error.required', { name: $t('manage-question.label.criteria') }) }}
              </small>
            </template>
            <template v-if="!$v.form.criteria.numeric && $v.form.criteria.$error">
              <small class="text-danger">
                {{ $t('manage-question.error.numeric') }}
              </small>
            </template>
          </div>
          <div class="row">
            <div class="col-sm-1">
              <img
                src="@/assets/icon/information.png"
                alt="information"
              >
            </div>
            <div class="col-sm-11">
              <div class="gray">
                <small>
                  {{ $t('manage-question.criteria.one') }}
                </small>
              </div>
              <div class="gray">
                <small>
                  {{ $t('manage-question.criteria.two') }}
                </small>
              </div>
              <div class="gray">
                <small>
                  {{ $t('manage-question.criteria.three') }}
                </small>
              </div>
              <div class="gray">
                <small>
                  {{ $t('manage-question.criteria.four') }}
                </small>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center my-3">
          <button
            v-if="!isLoadingSubmit"
            class="col-6 col-sm-2 btn btn-info"
            @click="submit"
          >
            {{ $t('manage-question.save') }}
          </button>
          <button
            v-else
            class="col-6 col-sm-2 btn btn-info"
          >
            <div class="spinner-border spinner-border-sm">
              <span class="sr-only">
                Loading...
              </span>
            </div>
          </button>
        </div>
      </div>
    </div>

    <modal-unsuccessful
      v-show="modal.unsuccessful"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
    <modal-success
      v-show="modal.success"
      :text-modal="modal.textModal"
      @closeModal="closeModal"
    />
  </portal>
</template>

<script>
import Api from '@/utils/Api'
import { required, numeric, helpers } from 'vuelidate/lib/validators'
import ModalSuccess from '@/components/modal/ModalSuccess'
import ModalUnsuccessful from '@/components/modal/ModalUnsuccessful'

export default {
  components: {
    ModalSuccess,
    ModalUnsuccessful
  },

  data: () => ({
    form: {
      risk: '',
      pattern: '',
      criteria: ''
    },
    modal: {
      textModal: '',
      success: false,
      unsuccessful: false
    },
    isLoadingSubmit: false
  }),

  methods: {
    showModal (modalname) {
      this.modal[modalname] = true
    },
    closeModal (modalname) {
      this.modal[modalname] = false
      if (modalname === 'success') {
        this.$emit('close', 'create')
      }
    },
    async submit () {
      this.$v.$touch()
      if (this.$v.$invalid) return

      this.isLoadingSubmit = true
      const formRegister = {
        riskLevel: this.form.risk,
        pattern: this.form.pattern,
        value: this.form.criteria
      }
      try {
        await Api.criteria.add(formRegister)
        this.modal.textModal = this.$t('manage-question.success-criteria')
        this.showModal('success')
        this.isLoadingSubmit = false
      } catch ({ response }) {
        this.modal.textModal = response.statusText
        this.showModal('unsuccessful')
        this.isLoadingSubmit = false
      }
    }
  },

  validations: {
    form: {
      risk: {
        required
      },
      pattern: {
        required,
        numeric: helpers.regex(numeric, /^[0-1,-]*$/i)
      },
      criteria: {
        required,
        numeric
      }
    }
  }
}
</script>

<style scoped>
.card {
  max-width: 600px;
  margin: 0 auto;
}
.gray {
  color: #848282;
}
</style>
